import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, PageHeader, Space } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useBack } from '@/hooks/useBack'

const UpdateCustomerPageHeader = () => {
  const { t } = useTranslation()
  const handleBack = useBack()

  return (
    <Space>
      <Button onClick={handleBack} icon={<ArrowLeftOutlined />} />
      <PageHeader ghost={false} title={t('components.pages.customers.update.pageHeader.title')} />
    </Space>
  )
}

UpdateCustomerPageHeader.displayName = 'UpdateCustomerPageHeader'
export default UpdateCustomerPageHeader
